"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DocumentPageCheckboxInput_1 = __importDefault(require("./DocumentPageCheckboxInput"));
var DocumentPageDateInput_1 = __importDefault(require("./DocumentPageDateInput"));
var DocumentPageNumberInput_1 = __importDefault(require("./DocumentPageNumberInput"));
var DocumentPageRadioInput_1 = __importDefault(require("./DocumentPageRadioInput"));
var DocumentPageSelectInput_1 = __importDefault(require("./DocumentPageSelectInput"));
var DocumentPageSignatureInput_1 = __importDefault(require("./DocumentPageSignatureInput"));
var DocumentPageTextInput_1 = __importDefault(require("./DocumentPageTextInput"));
var DocumentPageTimestampInput_1 = __importDefault(require("./DocumentPageTimestampInput"));
var types_1 = require("../../types");
var DocumentPageInput = function (_a) {
    var actor = _a.actor, isAutosignActive = _a.isAutosignActive, onChange = _a.onChange, onFocus = _a.onFocus, onReachMaxLength = _a.onReachMaxLength, input = _a.input;
    switch (input.kind) {
        case types_1.PageInputKind.Checkbox:
            return (react_1.default.createElement(DocumentPageCheckboxInput_1.default, { input: input, onChange: onChange, onFocus: onFocus }));
        case types_1.PageInputKind.Date:
            return (react_1.default.createElement(DocumentPageDateInput_1.default, { input: input, onChange: onChange, onFocus: onFocus }));
        case types_1.PageInputKind.Number:
            return (react_1.default.createElement(DocumentPageNumberInput_1.default, { input: input, onChange: onChange, onFocus: onFocus, onReachMaxLength: onReachMaxLength }));
        case types_1.PageInputKind.Radio:
            return (react_1.default.createElement(DocumentPageRadioInput_1.default, { input: input, onChange: onChange, onFocus: onFocus }));
        case types_1.PageInputKind.Select:
            return (react_1.default.createElement(DocumentPageSelectInput_1.default, { input: input, onChange: onChange, onFocus: onFocus }));
        case types_1.PageInputKind.Signature:
            return (react_1.default.createElement(DocumentPageSignatureInput_1.default, { actor: actor, input: input, isAutosignActive: isAutosignActive, onChange: onChange, onFocus: onFocus }));
        case types_1.PageInputKind.Text:
            return (react_1.default.createElement(DocumentPageTextInput_1.default, { input: input, onChange: onChange, onFocus: onFocus }));
        case types_1.PageInputKind.Timestamp:
            return (react_1.default.createElement(DocumentPageTimestampInput_1.default, { input: input, onChange: onChange, onFocus: onFocus }));
    }
};
exports.default = DocumentPageInput;
//# sourceMappingURL=index.js.map